
import Store from '../store/Store'

export default class {

    //options can contain: timeout

    static showAlert(message, options) {
        // console.log('AlertHelpers > showAlert')
        let alertObj
        if(options)
            alertObj = {...options, message, visible: true}
        else
            alertObj = {message, visible: true}
        
        alertObj.timeout = alertObj.timeout || 7000

        //show button for long alerts by default
        if(alertObj.button == null) {
            alertObj.button = (alertObj.timeout > 9000)
        }

        Store.dispatch('showAlert', alertObj)
    }

    static clearAlert() {
        Store.dispatch('clearAlert')
    }
}


// WEBPACK FOOTER //
// ./src/helpers/AlertHelpers.js